<template>
  <!-- 
    usage: 
    <Editor v-model="formData.editor" default-value="defaultValue" toolbar="bold | italic | styles | forecolor | image | emoticons | alignleft | aligncenter | alignright | alignjustify"></Editor>
  -->
  <TinyMceEditor
    class="tinymce-editor"
    v-model="myValue"
    :init="init"
    :disabled="disabled"
    @onClick="onClick"
  />
</template>

<script>
import {Message} from 'element-ui'
import tinymce from 'tinymce/tinymce' //tinymce默认hidden，
import TinyMceEditor from '@tinymce/tinymce-vue' //编辑器引入
import 'tinymce/themes/silver/theme' //编辑器主题
import 'tinymce/icons/default' //引入编辑器图标icon

// 更多插件参考：https://www.tiny.cloud/docs/plugins/
import 'tinymce/plugins/image'// 插入上传图片插件
import 'tinymce/plugins/wordcount'// 字数统计插件
import 'tinymce/plugins/paste';//复制粘贴图片
// import 'tinymce/plugins/fullscreen';//全屏插件
import 'tinymce/plugins/advlist' //高级列表
// import 'tinymce/plugins/autolink' //自动链接
// import 'tinymce/plugins/link' //超链接
import 'tinymce/plugins/lists' //列表插件
// import 'tinymce/plugins/charmap' //特殊字符
// import 'tinymce/plugins/media' //插入编辑媒体
// import 'tinymce/plugins/preview'
// import 'tinymce/plugins/imagetools'

import { postImageToQiNiuApi } from '@/api'

export default {
  components: {
    TinyMceEditor
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    //传入的默认值
    defaultValue: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      default: ''
    },
    /** 图片最大大小，单位：MB */
		maxSize: {
			type: Number,
			default: 3,
		},
		/** 是否限制上传的图片大小，如果不限制，`maxSize` 无效 */
		limitFileSize: {
			type: Boolean,
			default: true,
		},
    //是否禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //插件
    plugins: {
      type: [String, Array],
      default: 'image wordcount paste'
    },
    //菜单
    toolbar: {
      type: [String, Array],
      //如果显示的内容和配置的不符，表明插件未引入。需要去引入插件；
      // default: 'undo redo | styleselect | bold italic | styles | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | print preview media fullpage | forecolor backcolor emoticons'
      default: 'bold | italic | styles | forecolor | image | emoticons | alignleft | aligncenter | alignright | alignjustify'
    },
    //编辑器高度
    height:{
      default: 300,
    }
  },

  data() {
      let _this = this;
      return {
          myValue: '',
          editorId: null,

          init: {
              selector: '#tinymce',
              language_url: '/static/tinymce/langs/zh_CN.js',  //中文包路径地址
              language: 'zh_CN',
              skin_url: '/static/tinymce/skins/ui/oxide', //皮肤包路径地址
              height: this.height,//编辑器高度
              max_height: 550,//resize为true时，控制编辑器的最大高度
              plugins: this.plugins,  // 插件
              toolbar: this.toolbar,  // 工具栏
              images_upload_url: '', //上传路径
              elementpath: false,//标签路径是否显示
              menubar: false,//顶部文字操作菜单
              resize: this.disabled ? false:true,//页面大小拖动
              paste_data_images: true,//可以粘贴图片，需要引入paste插件
              // 图片或容器大小
              content_style:'div,p{margin:5px 0;}'+'img{max-width:100%;}'+'*::-webkit-scrollbar{width:6px;height:6px;background:transparent;}'+'*::-webkit-scrollbar-thumb{border-radius: 3px;background: #bac3d9;}',
              // 此处为图片上传处理函数，这个直接用了base64的图片形式上传图片
              // 直接使用base64处理，最好还是上传到服务器，因为base64存储到服务器数据库太庞大了
              // 配置列表：http://tinymce.ax-z.cn/configure/file-image-upload.php
              images_upload_handler(blobInfo, success, failure,progress) {
                  const fileType = blobInfo.blob().type
                  progress(0);
                  //格式校验
                  const isAccept = fileType === 'image/jpeg' || fileType === 'image/png' || fileType === 'image/GIF' || fileType === 'image/jpg' || fileType === 'image/BMP';
                  //大小校验
                  if (_this.limitFileSize && blobInfo.blob().size/1024/1024 > _this.maxSize) {
                      failure(`上传失败，图片大小请控制在 ${this.maxSize}M 以内`)
                      Message.warning(`上传失败，图片大小请控制在 ${this.maxSize}M 以内`)
                  } else if (!isAccept) {
                      Message.warning('图片格式错误')
                      failure('图片格式错误')
                  } else {
                      //上传
                      const formData = new FormData();
                      let extend = blobInfo.filename().split('.')
                      extend = extend[extend.length - 1]
                      formData.append('files', blobInfo.blob(), new Date().getTime()+`.${extend}`);
                      postImageToQiNiuApi(formData).then((result) => {
                          success(`https://${result.data.storageUrl}`)
                      }).catch(() => {
                          failure('上传失败')
                          Message.warning('上传失败')
                      })
                  }
              },
              init_instance_callback (editor) {
                  _this.editorId = editor.id;
              },

              branding: false,//隐藏右下角技术支持
          },
      }
  },
  mounted () {
    tinymce.init({})
  },
  methods: {
    onClick (e) {
      this.$emit('onClick', e, tinymce)
    },
  },
  watch: {
    myValue: {
      handler(newValue) {
        this.$emit('change', newValue)
      },
    },
    value: {
      immediate: true,
      handler(newValue) {
        this.myValue = newValue
      },
    },
  },
}
</script>

<style scoped>

</style>
